<template>
    <div id="promoters-page">
        <LandingBanner />
        <Simulator />
        <HowItWorks />
        <OwnSuccessStories />
        <Benefits />
        <Footer />
    </div>
</template>
  
<script>
import sal from 'sal.js';
import LandingBanner from '../../components/landing-components/promoters-components/LandingBanner.vue';
import Simulator from '../../components/landing-components/promoters-components/Simulator.vue';
import HowItWorks from '../../components/landing-components/promoters-components/HowItWorks.vue';
import OwnSuccessStories from '../../components/landing-components/promoters-components/OwnSuccessStories.vue';
import Benefits from '../../components/landing-components/promoters-components/Benefits.vue';
import Footer from '../../components/landing-components/promoters-components/Footer.vue';
export default {
    name: "PromotersPage",
    components: {
    LandingBanner,
    Simulator,
    HowItWorks,
    OwnSuccessStories,
    Benefits,
    Footer
},
    mounted() {
        sal();
    },
}
</script>
  
<style scoped></style>